import * as employeeList from '../services/employeeList';

export default {
  namespace: 'employeeList',
  state: {},
  effects: {
    //白名单
    *getQuerySendLog({ payload: { values }, callback }, { call, put }) {
      const response = yield call(employeeList.getQuerySendLog, values);
      yield put({
        type: 'save',
        payload: {
          sendLogList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
};
